import { useAuth } from "../../../context";
import { useQuery } from "react-query";
import { ConversionFactors } from "../../../api";

export const conversionFactorsKeys = {
  scopeOneConversionFactors: () => ["scopeOneConversionFactors"],
  scopeTwoConversionFactors: () => ["scopeTwoConversionFactors"],
  scopeThreeConversionFactors: () => ["scopeThreeConversionFactors"]
};

export function useGetScopeOneConversionFactors(params, config) {
  const { callApi } = useAuth();
  return useQuery([...conversionFactorsKeys.scopeOneConversionFactors(), params.year],
    () => callApi(ConversionFactors.getScopeOneConversionFactors, params), config);
}

export function useGetScopeTwoConversionFactors(params, config) {
  const { callApi } = useAuth();
  return useQuery([...conversionFactorsKeys.scopeTwoConversionFactors(), params.year],
    () => callApi(ConversionFactors.getScopeTwoConversionFactors, params), config);
}

export function useGetScopeThreeConversionFactors(params, config) {
  const { callApi } = useAuth();
  return useQuery([...conversionFactorsKeys.scopeThreeConversionFactors(), params.year],
    () => callApi(ConversionFactors.getScopeThreeConversionFactors, params), config);
}